import { Action, Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";
import { ThunkDispatch } from "redux-thunk";

import { Payload } from "@neworbit/redux-helpers";

import { clearReferralFormOrgStructures } from "@teamprevent/common/questionnaires/components/referralForm/actions";

import { loadAllowedProducts } from "../allowedProducts";
import { loadAllowedPhysioOrigins } from "../allowedPhysioOrigins";
import { loadAllowedCovid19Features } from "../allowedCovid19Features";
import { loadCustomerDetails } from "../customerDetails";
import { loadAllowedAssessmentAndWellBeingFeatures } from "../allowedAssessmentAndWellBeingFeatures";
import { loadOhCaseCount, loadWorkAdjustmentCount } from "../dashboard/actions";
import { loadCustomerSraDepartments } from "../customerSraDepartments";
import { ApplicationState } from "../applicationState";
import { clearOrgStructures, loadCurrentUserOrgStructureLevelOne } from "../orgStructure/actions";

import * as actions from "./actionTypes";
import * as models from "./model";
import CurrentUserApi from "./currentUserApi"; // eslint-disable-line import/no-named-as-default

export type CurrentUserAction =
    ({ type: typeof actions.GET_CURRENT_USER_SUCCESS } & Payload<models.CurrentUser>)
    | { type: typeof actions.CUSTOMER_MISMATCH };

export function getCurrentUser() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.GET_CURRENT_USER, CurrentUserApi.get());
        dispatch(getCurrentUserSuccess(result));
    };
}

export function updateTermsAccepted() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.UPDATE_TERMS_ACCEPTED, CurrentUserApi.updateTermsAccepted());
        dispatch(getCurrentUserSuccess(result));
    };
}

export function changeCurrentUserCompanyContext(companyId: string) {
    return async (dispatch: ThunkDispatch<ApplicationState, undefined, Action>) => {
        const result = await loadAndTrack(dispatch, actions.GET_CURRENT_USER, CurrentUserApi.changeCompanyContext(companyId));

        await dispatch(getCurrentUserSuccess(result));

        const currentCustomerId = result.currentCustomer?.id;
        await Promise.all([
            dispatch(loadAllowedProducts()),
            dispatch(loadAllowedPhysioOrigins()),
            dispatch(loadAllowedCovid19Features()),
            dispatch(loadCustomerDetails()),
            dispatch(loadOhCaseCount()),
            dispatch(loadWorkAdjustmentCount()),
            dispatch(loadAllowedAssessmentAndWellBeingFeatures()),
            dispatch(clearOrgStructures()),
            dispatch(clearReferralFormOrgStructures()),
            dispatch(loadCurrentUserOrgStructureLevelOne(currentCustomerId)),
            dispatch(loadCustomerSraDepartments())
        ]);
    };
}

export const getCurrentUserSuccess = (payload: models.CurrentUser): CurrentUserAction => ({
    payload,
    type: actions.GET_CURRENT_USER_SUCCESS
});

export const customerIdMismatch = (): CurrentUserAction => ({
    type: actions.CUSTOMER_MISMATCH
});
